<template>
  <section class="cabinet-main">
    <div class="cabinet__blocks _mb-6">
      <div
        class="cabinet__block _px-6 _py-8 _pa-sm-4 _br--2"
        style="background-color: #ffe48c"
        @click="userDataClick()"
      >
        <div>
          <div class="_fs-20 _fs-sm-16 _lh-26 _tc-dark _mb-1 _fw-700">
            {{ $t('cabinet.dashboard.cards[0].title') }}
          </div>
          <div
            class="_mt-2 _mr-8 _mr-sm-0 _fs-16 _fs-sm-14 _lh-26 _lh-sm-20 _tc-dark-grey"
          >
            {{ $t('cabinet.dashboard.cards[0].description') }}
          </div>
          <div class="user-info _mt-4">
            <div class="user-info__avatar _mr-2">
              <svg
                v-if="!user.photo"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 18.3747V16.6247C17.5 15.6965 17.1313 14.8062 16.4749 14.1499C15.8185 13.4935 14.9283 13.1247 14 13.1247H7C6.07174 13.1247 5.1815 13.4935 4.52513 14.1499C3.86875 14.8062 3.5 15.6965 3.5 16.6247V18.3747"
                  stroke="#B2B4B2"
                  stroke-width="1.25806"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.4995 9.62474C12.4325 9.62474 13.9995 8.05774 13.9995 6.12474C13.9995 4.19174 12.4325 2.62474 10.4995 2.62474C8.56651 2.62474 6.99951 4.19174 6.99951 6.12474C6.99951 8.05774 8.56651 9.62474 10.4995 9.62474Z"
                  stroke="#B2B4B2"
                  stroke-width="1.25806"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <img v-else :src="'/' + user.photo" />
            </div>
            <div class="user-info__text">
              <div class="_fs-20 _fs-sm-16 _lh-26 _tc-dark _fw-700">
                {{ user.username }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="user-info__bottom _mt-md-0 _mx-md-auto _mx-sm-3 _mt-auto d-flex align-start align-xl-end"
        >
          <div
            class="user-info__status d-flex align-center justify-center justify-xl-start direction-column direction-xl-row"
          >
            <svg
              class="circle-progress"
              width="94"
              height="94"
              viewBox="0 0 94 94"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="47"
                cy="47"
                r="40"
                stroke="#F8F8F8"
                :stroke-dasharray="Math.PI * (40 * 2)"
                stroke-width="14"
              />
              <circle
                class="circle-progress__circle"
                cx="47"
                cy="47"
                r="40"
                stroke="#77BB2F"
                stroke-width="14"
                :stroke-dasharray="Math.PI * (40 * 2)"
                :style="`stroke-dashoffset: ${
                  Math.PI * (40 * 2) -
                  (Math.floor(user.level_progress * 100) / 100) *
                    (Math.PI * (40 * 2))
                }`"
              />
            </svg>

            <div
              class="_ml-4 _ml-md-0 _fw-700 _fs-32 _fs-md-24 _fs-sm-16 _lh-md-32 _lh-38 _tc-dark d-flex justify-center"
            >
              {{ $t(`cabinet.dashboard.levels[${user.level}]`) }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="cabinet__block _px-6 _py-8 _pa-sm-4 _br--2"
        style="background-color: #ebf6e3"
        @click="prizesClick()"
      >
        <div class="_mb-auto">
          <div class="_fs-20 _fs-sm-16 _lh-26 _tc-dark _mb-1 _fw-700">
            {{ $t('cabinet.dashboard.cards[1].title') }}
          </div>
          <div
            class="_mt-2 _mr-8 _mr-sm-0 _fs-16 _fs-sm-14 _lh-26 _lh-sm-20 _tc-dark-grey"
          >
            {{ $t('cabinet.dashboard.cards[1].description') }}
          </div>
        </div>
        <div class="user-info__bottom d-flex align-end">
          <div class="user-info__status _mr-8 _mx-sm-4">
            <div
              class="d-flex align-center justify-center direction-column direction-md-row"
            >
              <img
                class="_mr-4 _mr-sm-0 _mb-sm-1 user-info__icon"
                :src="require('@/assets/img/cabinet/coins_icon.png')"
              />
              <div class="_fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _tc-dark _fw-600">
                {{ user.balance }}
                <span class="_fs-16 _lh-24 _tc-dark d-block _fw-400">
                  {{ $tc('cabinet.dashboard.cards[1].tip', user.balance) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="cabinet__block _px-6 _py-8 _px-sm-4 _br--2"
        style="background-color: #dc6dab"
        @click="achievementsClick()"
      >
        <div class="_mb-auto">
          <div class="_fs-20 _fs-sm-16 _lh-26 _tc-white _mb-1 _fw-700">
            {{ $t('cabinet.dashboard.cards[2].title') }}
          </div>
          <div class="_mt-2 _mr-8 _mr-sm-0 _fs-16 _fs-sm-14 _lh-26 _tc-white">
            {{ $t('cabinet.dashboard.cards[2].description') }}
          </div>
        </div>
        <div class="user-info__bottom d-flex align-end">
          <div class="user-info__status _mr-8 _mx-sm-4">
            <div
              class="d-flex align-center justify-center direction-column direction-md-row"
            >
              <img
                class="_mr-4 _mr-sm-0 _mb-sm-1 user-info__icon"
                :src="require('@/assets/img/cabinet/cup_icon.png')"
              />
              <div
                class="_fs-32 _fs-sm-24 _lh-sm-32 _lh-38 _tc-white _fw-600"
                v-if="Achievements && Achievements.achievements"
              >
                {{ Achievements.achievements.captured }}
                <span class="_fs-16 _lh-24 _tc-white d-block _fw-400">
                  {{
                    $tc(
                      'cabinet.dashboard.cards[2].tip',
                      Achievements.achievements.captured
                    )
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cabinet__pages _mt-md-8">
      <div
        class="cabinet__card _mr-md-0 _mr-sm-2 _mr-4 _mb-md-8 _mb-sm-0 _br--2 _pl-6 _pr-0 _px-sm-4"
        style="background-color: #fff7e4"
        @click="favoritesClick()"
      >
        <div class="d-flex direction-column direction-md-row">
          <div
            class="_py-8 _py-sm-6 _pr-sm-0 _pr-md-8 card__text d-flex direction-md-column direction-row"
          >
            <div>
              <div class="_fs-20 _fs-sm-16 _lh-24 _tc-dark _mb-2 _fw-700">
                {{ $t('cabinet.favorites.title') }}
              </div>
              <div
                class="_fs-16 _lh-24 _tc-dark-grey _mb-2"
                v-html="$t('cabinet.favorites.description')"
              ></div>
            </div>

            <svg
              class="_mt-sm-0 _ml-sm-2 _mt-auto cabinet__block-icon"
              viewBox="0 0 78 78"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="78" height="78" rx="39" fill="white" />
              <path
                d="M37.8685 27.6605C38.3184 26.702 39.6816 26.702 40.1315 27.6605L42.9656 33.6979C43.1426 34.0749 43.4957 34.3389 43.9073 34.4022L50.3471 35.392C51.3525 35.5465 51.7622 36.773 51.0516 37.5007L46.3159 42.351C46.0386 42.635 45.9127 43.0338 45.9766 43.4255L47.083 50.209C47.251 51.2389 46.1576 52.0091 45.2444 51.5041L39.6049 48.3855C39.2285 48.1774 38.7715 48.1774 38.3951 48.3855L32.7556 51.5041C31.8424 52.0091 30.749 51.2389 30.917 50.209L32.0234 43.4255C32.0873 43.0338 31.9614 42.635 31.6841 42.351L26.9484 37.5007C26.2378 36.773 26.6475 35.5465 27.6529 35.392L34.0927 34.4022C34.5043 34.3389 34.8574 34.0749 35.0344 33.6979L37.8685 27.6605Z"
                stroke="#FED141"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <img
            class="_ml-xl-16 _ml-sm-16 _ml-md-14 _pt-5"
            :src="require('@/assets/img/cabinet/card-1.png')"
          />
        </div>
      </div>
      <div
        class="cabinet__card _ml-md-0 _ml-4 _ml-sm-2 _br--2 _pl-6 _pr-0 _px-sm-4"
        style="background-color: #e4f4ff"
        @click="statisticClick()"
      >
        <div class="d-flex direction-column direction-md-row">
          <div
            class="_py-8 _py-sm-6 card__text d-flex direction-md-column direction-row"
          >
            <div>
              <div class="_fs-20 _fs-sm-16 _lh-24 _tc-dark _mb-2 _fw-700">
                {{ $t('cabinet.statistic.title') }}
              </div>
              <div
                class="_fs-16 _lh-24 _tc-dark-grey _mb-2"
                v-html="$t('cabinet.statistic.description')"
              ></div>
            </div>
            <svg
              class="_mt-sm-0 _ml-sm-2 _mt-auto cabinet__block-icon"
              viewBox="0 0 78 78"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="78" height="78" rx="39" fill="white" />
              <path
                d="M27.75 27.75V47.75C27.75 48.413 28.0134 49.0489 28.4822 49.5178C28.9511 49.9866 29.587 50.25 30.25 50.25H50.25"
                stroke="#69B3E7"
                stroke-width="2.5"
                stroke-miterlimit="5.759"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M32.75 41.5L37.75 36.5L42.75 41.5L50.25 34"
                stroke="#69B3E7"
                stroke-width="2.5"
                stroke-miterlimit="5.759"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M46.5 34H50.25V37.75"
                stroke="#69B3E7"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <picture>
            <source
              :srcset="require('@/assets/img/cabinet/card-2_mob.png')"
              media="(max-width: 743px)"
            />
            <source
              :srcset="require('@/assets/img/cabinet/card-2.png')"
              media="(min-width: 744px)"
            />
            <img
              class="_ml-md-10"
              :src="require('@/assets/img/cabinet/card-2.png')"
            />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import AppBtn from '../../components/UI/buttons/AppBtn.vue'
import { bus } from '@/main'
export default {
  metaInfo() {
    return { title: this.$t('cabinet.title') }
  },
  name: 'Main',
  // components: { AppBtn },
  data: () => ({}),
  computed: {
    ...mapGetters(['Rules', 'user', 'Achievements']),
  },
  methods: {
    ...mapActions(['fetchLogout', 'fetchAchievements', 'SOCKET_SEND_MESSAGE']),
    logout() {
      this.fetchLogout()
      this.userMenu = false
      bus.$emit('scrollLock', false)
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_lk_menu',
          param_value: this.$t('interface.logout'),
        })
      }
      this.$router.push(this.helpers.buildRoute({ name: 'Home' }))
    },
    favoritesClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'lk_goto_favorite',
        })
      }
      this.$router.push(this.helpers.buildRoute({ name: 'Favorites' }))
    },
    statisticClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'lk_goto_statistic',
        })
      }
      this.$router.push(this.helpers.buildRoute({ name: 'Statistics' }))
    },
    userDataClick() {
      // if (this.$gtm) {
      //   this.$gtm.push({
      //     event: 'lk_goto_favorite',
      //   })
      // }
      this.$router.push(this.helpers.buildRoute({ name: 'CabinetUserData' }))
    },
    prizesClick() {
      // if (this.$gtm) {
      //   this.$gtm.push({
      //     event: 'lk_goto_statistic',
      //   })
      // }
      this.$router.push(this.helpers.buildRoute({ name: 'CabinetPrizes' }))
    },
    achievementsClick() {
      // if (this.$gtm) {
      //   this.$gtm.push({
      //     event: 'lk_goto_statistic',
      //   })
      // }
      this.$router.push(
        this.helpers.buildRoute({ name: 'CabinetAchievements' })
      )
    },
  },
  async mounted() {
    await this.fetchAchievements()
    this.SOCKET_SEND_MESSAGE(
      JSON.stringify({
        action: 'set_path',
        path: this.$router.resolve({
          name: this.$route.name.replace('Loc', ''),
        }).href,
      })
    )
  },
}
</script>

<style lang="scss" scoped>
.circle-progress {
  position: relative;
  flex-shrink: 0;

  @media screen and (max-width: 743px) {
    width: 80px;
    height: 80px;
  }

  &__circle {
    transform: rotate(-90deg);
    stroke-linecap: round;
    transform-origin: center;
  }
}

.cabinet {
  &__pages {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media screen and (max-width: 1220px) {
      display: block;
    }

    @media screen and (max-width: 743px) {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
    }
  }
  &__card {
    cursor: pointer;
    width: 50%;
    height: 257px;
    border: 1px solid #d1d2cd;
    position: relative;
    transition: 0.3s;

    &:first-child {
      &:hover {
        background-color: #ffcb9a !important;
      }
    }

    &:nth-child(2) {
      &:hover {
        background-color: #c3def1 !important;
      }
    }

    & > div {
      height: 100%;
    }
    @media screen and (max-width: 1220px) {
      width: 100%;
    }
    @media screen and (max-width: 743px) {
      // height: 295px;
      height: auto;
      width: calc(50% - 8px);
    }
    .card__text {
      @media screen and (max-width: 743px) {
        position: relative;
        z-index: 2;
        height: 100%;
        display: flex;
        // flex-direction: column;
      }
    }
    img {
      // width: 37%;
      height: 100%;
      object-fit: contain;
      flex-shrink: 0;

      @media screen and (max-width: 1220px) {
        width: auto;
      }

      @media screen and (max-width: 743px) {
        // position: absolute;
        // bottom: 0;
        // left: 50%;
        // transform: translateX(-50%);
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        height: 100px;
      }
    }
  }
  &__blocks {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 32px;

    @media screen and (max-width: 1220px) {
      display: flex;
      flex-wrap: wrap;
      column-gap: 32px;
      row-gap: 32px;
    }

    @media screen and (max-width: 743px) {
      grid-template-rows: repeat(3, 1fr);
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 32px;
    }
  }
  &__block {
    border: 1px solid #d1d2cd;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 335px;
    transition: 0.3s;
    cursor: pointer;

    &:first-child {
      &:hover {
        background-color: #f6d66d !important;
      }
    }

    &:nth-child(2) {
      &:hover {
        background-color: #b6e287 !important;
      }
    }

    &:nth-child(3) {
      &:hover {
        background-color: #b75b8e !important;
      }
    }

    @media screen and (min-width: 744px) and (max-width: 1220px) {
      width: calc(50% - 16px);
      // width: 100%;
    }

    @media screen and (max-width: 1220px) {
      &:first-child {
        width: 100%;
        flex-direction: row;
        height: auto;
      }
    }

    @media screen and (max-width: 743px) {
      width: 100%;
      flex-direction: row;
      height: auto;
    }

    &-icon {
      width: 78px;
      height: 78px;
      flex-shrink: 0;

      @media screen and (max-width: 743px) {
        width: 28px;
        height: 28px;
      }
    }
  }
}

.user-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &__avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8f8f8;
    border: 1px solid #d1d2cd;

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 50%;
    }
  }

  &__status-item {
    background: #ebf6e3;
    border: 1px solid #77bb2f;
    border-radius: 16px;
  }

  &__status {
    @media screen and (max-width: 743px) {
      text-align: center;
    }
  }

  &__icon {
    width: 140px;
    height: 140px;

    @media screen and (max-width: 743px) {
      width: 65px;
      height: 65px;
    }
  }
}
</style>
